module.exports = __webpack_public_path__ + "img/taobao.ed895bca.png";